// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchCatalogsTodayCountApiParams = {
    deployment: string,
};

export const fetchCatalogsTodayCountApi = ({ deployment }: FetchCatalogsTodayCountApiParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makeGet({ deployment, path: '<ITEM-API>spa/small/catalogtodaycount' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};

type FetchResultsApiParams = {
    catalogSearchQuery: any,
    deployment: string,
};

export const fetchResultsApi = ({ catalogSearchQuery, deployment }: FetchResultsApiParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'auctioncalendar',
            deployment,
            path: '<SEARCH-API>',
            queryParams: catalogSearchQuery,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};
